import { Observable } from 'rxjs';
import { ModelResponseDeleteAdvertisement } from '../../models/http-responses/delete-advertisement-response.model';

export abstract class AbstractServiceAdvertisement {
    abstract deleteAdvertisement(organizationId: string, advertisementId: string): Observable<ModelResponseDeleteAdvertisement>;
}
